var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManageProgram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Manage Rules"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.333 4H17.2497C17.758 4 18.2455 4.21071 18.605 4.58579C18.9644 4.96086 19.1663 5.46957 19.1663 6V20C19.1663 20.5304 18.9644 21.0391 18.605 21.4142C18.2455 21.7893 17.758 22 17.2497 22H5.74967C5.24134 22 4.75383 21.7893 4.39439 21.4142C4.03494 21.0391 3.83301 20.5304 3.83301 20V6C3.83301 5.46957 4.03494 4.96086 4.39439 4.58579C4.75383 4.21071 5.24134 4 5.74967 4H7.66634",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.542 10L16.292 10",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.625 9L6.77679 11L5.75 10.2727",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.66667 13L5.75 15",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.75 13L7.66667 15",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.625 17L6.77679 19L5.75 18.2727",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M10.542 14L16.292 14",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M10.542 18L16.292 18",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M14.3753 2H8.62533C8.09605 2 7.66699 2.44772 7.66699 3V5C7.66699 5.55228 8.09605 6 8.62533 6H14.3753C14.9046 6 15.3337 5.55228 15.3337 5V3C15.3337 2.44772 14.9046 2 14.3753 2Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageProgram);
export default __webpack_public_path__ + "static/media/manage-program.a5288ad705d3de315c51c0398f409241.svg";
export { ForwardRef as ReactComponent };